// extracted by mini-css-extract-plugin
module.exports = {"header":"fd7e0","label":"_24bce","picture-list":"eaf45","pictureList":"eaf45","list-item":"a2565","listItem":"a2565"};